import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import router from "./routes";
import "./index.css";
import "react-quill/dist/quill.snow.css";

const root = createRoot(document.getElementById("root"));
root.render(<RouterProvider router={router} />);
